import { Component } from '../../../libs/gin-tonic/helpers/compiler';

import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Keyboard } from 'swiper/modules';
import { SwiperOptions } from '../../../node_modules/swiper/types/swiper-options';
import { asHTMLElement } from '../../../libs/gin-tonic/helpers/dom/as-html-element/index';

@Component({ className: 'js-swiper' })
export class SwiperComponent {
	private slideDescription: string;
	constructor(public element: HTMLElement) {
		this.slideDescription = element.getAttribute('data-slide-description') ?? '';

		const sliderType = element.getAttribute('data-slider') ?? '';
		const sliderDelay = element.getAttribute('data-delay') ?? '2500';
		const delay = parseFloat(sliderDelay);
		const swiperParams = this.getParamsFromType(sliderType, delay);
		const swiper = new Swiper(element, swiperParams);
	}

	private getParamsFromType(sliderType: string, delay: number): SwiperOptions | undefined {
		switch (sliderType) {
			case 'keyVisual': {
				const keyVisualOptions: SwiperOptions = {
					modules: [Pagination, Autoplay, Keyboard],
					loop: true,

					direction: 'horizontal',
					autoHeight: true,
					breakpoints: {
						992: {
							direction: 'vertical'
						}
					},
					pagination: {
						el: `.swiper-pagination`,
						type: 'bullets',
						clickable: false,
						renderBullet: function (index, className) {
							// Add role to each bullet element
							return `<span class="${className}" role="none"></span>`;
						}
					},
					slidesPerView: 1,
					spaceBetween: 0,
					grabCursor: true,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
						pageUpDown: true
					},
					on: {
						init: swiper => {
							swiper.slides.forEach((slide, index) => {
								slide.setAttribute(
									'aria-label',
									this.slideDescription
										.split('[0]')
										.join(`${index + 1}`)
										.split('[1]')
										.join(`${swiper.slides.length}`)
								);

								slide.addEventListener('click', () => {
									slide.focus();
								});
								slide.addEventListener('blur', () => {
									const isAnySlideFocused = Array.from(swiper.slides).some(slide => document.activeElement === slide);

									if (!isAnySlideFocused) {
										if (swiper.params.autoplay && !swiper.autoplay.running) {
											swiper.autoplay.start();
										}
									}
								});

								slide.addEventListener('focus', event => {
									event.preventDefault();
									event.stopPropagation();
									swiper.autoplay?.stop();
									swiper.slideTo(index);
									swiper.el.scrollTo(0, 0);
								});
							});
						}
					}
				};

				if (delay > 0) {
					keyVisualOptions.autoplay = {
						delay: delay,
						disableOnInteraction: false
					};
				}

				return keyVisualOptions;
			}
			case 'media': {
				const keyVisualOptions: SwiperOptions = {
					modules: [Pagination, Navigation, Autoplay],
					loop: true,

					pagination: {
						el: `.swiper-pagination`,
						type: 'bullets',
						clickable: false,
						renderBullet: function (index, className) {
							// Add role to each bullet element
							return `<span class="${className}" role="none"></span>`;
						}
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					slidesPerView: 1,
					spaceBetween: 0,
					grabCursor: true,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
						pageUpDown: true
					},
					on: {
						init: swiper => {
							swiper.slides.forEach((slide, index) => {
								slide.setAttribute(
									'aria-label',
									this.slideDescription
										.split('[0]')
										.join(`${index + 1}`)
										.split('[1]')
										.join(`${swiper.slides.length}`)
								);

								slide.addEventListener('click', () => {
									slide.focus();
								});

								slide.addEventListener('blur', () => {
									const isAnySlideFocused = Array.from(swiper.slides).some(slide => document.activeElement === slide);

									if (!isAnySlideFocused) {
										if (swiper.params.autoplay && !swiper.autoplay.running) {
											swiper.autoplay.start();
										}
									}
								});

								slide.addEventListener('focus', event => {
									event.preventDefault();
									event.stopPropagation();
									swiper.autoplay?.stop();
									swiper.slideTo(index);
									swiper.el.scrollTo(0, 0);
								});
							});
						}
					}
				};

				if (delay > 0) {
					keyVisualOptions.autoplay = {
						delay: delay,
						disableOnInteraction: false
					};
				}
				return keyVisualOptions;
			}
		}
	}
}
